import UserSettings from '../components/UserSettings';

const UserSettingsPage = () => {
  return <UserSettings />;
};

export default UserSettingsPage;
